import { AiOutlineMenu } from "react-icons/ai";

import "./style.css";
import { useContext } from "react";
import { DasboardContext } from "../../context/dashboard-context";

const Breadcrumb = ({ showPath }) => {
  const { sidebarOpen, setSidebarOpen } = useContext(DasboardContext);

  return (
    <div className={`breadcrumb-wrapper ${sidebarOpen ? "" : "close"}`}>
      <div>
        <AiOutlineMenu onClick={() => setSidebarOpen(!sidebarOpen)} />
        <p>Viva Smart Care</p>
      </div>
      <div>
        <p>Hoşgeldiniz, admin.</p>
      </div>
    </div>
  );
};

export default Breadcrumb;
